<div class="dialog-container green-theme">
  <div class="dialog-header">
    <h4 class="dialog-heading">{{data.isDuplicate ? 'Duplicate': data.isEdit ? 'Edit': 'New'}} Playlist</h4>
    <button type="button" class="close-button" (click)="close()">
      <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Nav-Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
          stroke-linejoin="round">
          <g id="Genre" transform="translate(-1438.000000, -32.000000)" class="inner-stroke" stroke="#FFFFFF">
            <g id="Genre-Options">
              <g id="Close" transform="translate(1439.000000, 32.000000)">
                <path d="M24,0 L0,24" id="Path"></path>
                <path d="M0,0 L24,24" id="Path"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </button>
  </div>

  <mat-dialog-content style="max-height:80vh;">
   
    <div class="container-image" >
      <p>Add an image to save a playlist to CMS</p>
    </div>
    <app-loader *ngIf="loading" color="#50e3c2"></app-loader>
    <div class="dialog-body" *ngIf="!loading">
      <!-- <div class="form-row" style="font-size: 12px;" *ngIf="data.isDuplicate && !data.isEdit">
        <mat-checkbox
          [checked]="false" >
          <span class="check-text">Make playlist public</span>
         
          
        </mat-checkbox>
      </div> -->
      <div class="form-row" style="font-size: 12px;">
       
        <mat-checkbox 
          [checked]="cms"   (change)="checkCms($event.checked)">
          <span class="check-text">Add to CMS</span>
        </mat-checkbox>
      </div>
      <div class="form-container">
        <mat-form-field class="dialog">
          <mat-label>Playlist &nbsp;&nbsp;Title</mat-label>
          <input [(ngModel)]="title" matInput >
        </mat-form-field>
      </div>
      <p class="note">Please make title as short and descriptive as possible</p>
      
      <div class="notes-contaner"  style="margin-bottom: 30px;">
        <h6>Notes</h6>
        <textarea  [(ngModel)]="note" rows="5" style="resize: vertical;flex-grow: 1;" maxlength="500"  placeholder="Type here...">
      </textarea>
      <!-- <mat-hint class="char-limit"></mat-hint> -->
      <p class="note" style="margin-top: -6px;">Max Characters 500</p>
      </div>
      <div class="imgfile-container"  style="margin-bottom: 30px;">
        <div class="form-container">
          <mat-form-field class="dialog">
            <mat-label>image</mat-label>
            <input class="wrap-textfilename" placeholder="File name"  [(ngModel)]="image" readonly  matInput>
            <!-- <button type="button" class="btn-filechoosen">choose file
            <input   type="file" enctype="multipart/form-data" (change)="onSelectFile($event)" multiple></button> -->
            <div class="file-input" style="position: absolute;
            right: 4%;
            top: 24%;">
              <input 
                type="file"
                name="file-input"
                id="file-input"
                #myFileInput
                class="file-input__input" accept="image/*"   (change)="fileChange($event)" (click)="onFileChange($event)">
              <label class="file-input__label" for="file-input">
                <span>choose file</span></label>
            </div>
          </mat-form-field>
         
        </div>
        <p class="note" style="position: relative;margin-bottom: 35px;" >Aspect Ratio – 16:9  (jpeg)
          <span style="position: absolute;right:34%;">Max file size: 500KB</span>
          </p>
          <!-- <div *ngIf="maximumError" class="container-image" style="margin-bottom: 15px;">
            <p>Max file size: 500KB, Please upload less then 500KB</p>
          </div> -->
          <div *ngIf="maximumDimention" class="container-image" style="margin-bottom: 15px;">
            <p>Please upload the correct valid Dimension image</p>
          </div>
          <div *ngIf="show" class="crop-style" style=" box-shadow: 0 10px 20px rgb(0 0 0 / 19%), 0 6px 6px rgb(0 0 0 / 23%);margin-top: 10px" >

            <image-cropper
         [imageChangedEvent]="imageChangedEvent"
         [maintainAspectRatio]="false"
         [containWithinAspectRatio]= 'false'
         [aspectRatio]="16 / 9"
         format="png"
         cropperMinWidth="200"
         cropperMinHeight="200"
         (imageCropped)="imageCropped($event)"
         (imageLoaded)="imageLoaded($event)"
         (cropperReady)="cropperReady()"
         (loadImageFailed)="loadImageFailed()"
        ></image-cropper>

        <!-- <mat-label>{{isThumb_img? 'Thumb Image': 'Marquee Image'}}</mat-label>

        <div *ngIf="ready">
          <button (click)="cropper.zoomIn()" ly-button appearance="icon"><ly-icon>zoom_in</ly-icon></button>
          <button (click)="cropper.zoomOut()" ly-button appearance="icon"><ly-icon>zoom_out</ly-icon></button> -->
          <!-- <button (click)="cropper.center()" ly-button appearance="icon"><ly-icon>filter_center_focus</ly-icon></button> -->
          <!-- <button (click)="cropper.rotate(-90)" ly-button appearance="icon"><ly-icon>rotate_90_degrees_ccw</ly-icon></button> -->
          <!-- <button (click)="cropper.fit()" ly-button>Fit</button>
          <button (click)="cropper.fitToScreen()" ly-button>Fit to screen</button> -->
          <!-- <button (click)="cropper.setScale(1)" ly-button>1:1</button> -->
          <!-- <button (click)="cropper.clean()" ly-button>Clean</button> -->

          <!-- <span *ngIf="ready" [className]="classes.sliderContainer">
            <ly-slider
              [thumbVisible]="false"
              [min]="minScale"
              [max]="1"
              [(ngModel)]="scale"
              (input)="onSliderInput($event)"
              [step]="0.000001"></ly-slider>
          </span>
        </div>
        
        <ly-img-cropper [withClass]="classes.cropper" style="margin-bottom: 20px;margin:0 auto;"
          [config]="myConfig"
          [(scale)]="scale"
          (minScale)="minScale = $event"
          (ready)="ready = true"
          (cleaned)="ready = false"
          (cropped)="onCropped($event)"
          (loaded)="onLoaded($event)"
          (error)="onError($event)"
        > -->
        <!-- <span>Drag and drop image</span> -->
        <!-- </ly-img-cropper> -->
        
      
        <div *ngIf="show" style="
       margin-top: 5%;">
            <button mat-button color="primary" class="crop-btn"  (click)="cropData()">ok</button>
             <button mat-button color="primary" class="crop-btn" (click)="toggleclose()">cancel</button>
              <!-- <mat-slide-toggle
              [checked]="isThumb_img"
              (toggleChange)="handleToggle()"
              >{{isThumb_img? 'Thumb Image': 'Marquee Image'}}
              </mat-slide-toggle> -->
             <!-- <button mat-button color="primary" class="crop-btn"  >Redo</button>
             <button mat-button color="primary" class="crop-btn" >Undo</button> -->
         </div>
           </div>

           <div *ngIf="showCropper" class="crop-style" style=" width: 72% !important;
           position: inherit; box-shadow: 0 10px 20px rgb(0 0 0 / 19%), 0 6px 6px rgb(0 0 0 / 23%);" >
           <!-- <mat-label>{{isThumb_img? 'Thumb Image': 'Marquee Image'}}</mat-label> -->
            <aspect-ratio style="margin:0;" baseWidth="1" baseHeight="1">
              <div class="content"> <img style="object-fit: fill;
                height: 200px;width: 200px; margin-left: 17%;"  [src]="croppedImage"> <br/></div>
            </aspect-ratio>
            <!-- <ng-template #marquee_Img>
              <aspect-ratio style="margin:0;" baseWidth="16" baseHeight="9">
                <div class="content"> <img style="object-fit: fill;
                  height: 198px;width: 352px; margin-left: 10%;"  [src]="croppedImage"> <br/></div>
              </aspect-ratio>
            </ng-template> -->
            <div *ngIf="showCropper" style="margin-bottom: -4%;margin-left: 30%">
              <button mat-button color="primary" class="crop-btn"  (click)="crop()">save</button>
               <button mat-button color="primary" class="crop-btn" (click)="resetCrop()">Reset</button>
           </div>
          </div>
          <div class="imgstore-container" style="display: inline-flex;width: 250px;
          height: 160px;" >
            <img style="object-fit: cover;" [src]="imageLink" (error)="onInvalidImg($event, 'main')">
            <aspect-ratio style="margin:0;" baseWidth="1" baseHeight="1">
              <div class="content"> <img style="width: 160px;object-fit: fill;
                height: 160px;"  [src]="finalImg" (error)="onInvalidImg($event, 'thumb')"> <br/></div>
            </aspect-ratio>
          </div>
        
         
      </div>

      <div class="add-to-folder form-container">
        <p class="label">Add to Available Folder<span class="deselect"  (click)="deselectPlaylist($event)"><small>Deselect all &nbsp;({{this.checkedFolders.length>0 ? this.checkedFolders.length : '0'}})</small></span></p>
        <input class="search"
          placeholder="Find a folder"
          [formControl]="searchControl">
        <ul class="list" *ngIf="!searchingFolders">
          <li *ngFor="let folder of folderOptions | async; trackBy:folderTrackBy">
            <mat-checkbox [checked]="isFolderChecked(folder)"  (change)="folderChecked($event.checked, folder)">
              <span class="check-text">{{folder.getDisplayName()}}</span>
            </mat-checkbox>
          </li>
        </ul>
        
        <div class="no-groups" *ngIf="!searchingFolders && folders.length <= 0">
          <p>There are currently no groups available. Create a new playlist group to add your playlist</p>
        </div>
        <app-loader *ngIf="searchingFolders" color="#50e3c2"></app-loader>
      </div>
      <div class="group-item" *ngIf="!data.isDuplicate" >
        <p>Select a folder(s) to add playlist</p>
      </div>
      <div class="group-item" *ngIf="data.isDuplicate" >
        <p>Description of action</p>
      </div>
      <div class="form-row">
        <mat-checkbox
          [(ngModel)]="newPlaylistFolder">
          <span class="check-text">Create New Playlist Folder</span>
        </mat-checkbox>
      </div>
      <div class="form-container" *ngIf="newPlaylistFolder">
        <mat-form-field class="dialog">
          <mat-label>New Playlist Folder Name</mat-label>
          <input [(ngModel)]="folderName" matInput>
        </mat-form-field>
      </div>
      <p class="error" *ngIf="error">{{error}}</p>
      <div class="form-col buttons">
        <!-- <button class="form-button" (click)="duplicate()" [disabled]="!canSubmit() || disableSave">Save</button> -->
        <button class="form-button" (click)="duplicate()" [disabled]="!canSubmit()">Save</button>
        <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  